import Vue from 'vue';
import Router from 'vue-router';

import signInPage from './views/authorization/signInPage/signInPage.vue';
import intermediariesPage from './views/intermediaries/intermediariesPage/intermediariesPage.vue';
import systemsPage from './views/systems/systemsPage/systemsPage.vue';
import institutionsPage from './views/institutions/institutionsPage/institutionsPage.vue';
import usersPage from './views/users/usersPage/usersPage.vue';
import userProfilePage from './views/users/userProfilePage/userProfilePage.vue'
import surveysPage from './views/surveys/surveysPage/surveysPage.vue';
import surveyInfoPage from './views/surveys/surveyInfoPage/surveyInfoPage.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/signIn',
            name: 'signIn',
            component: signInPage
        },
        {
            path: '/intermediaries',
            name: 'intermediaries',
            component: intermediariesPage,
        },
        {
            path: '/systems',
            name: 'systems',
            component: systemsPage
        },
        {
            path: '/institutions',
            name: 'institutions',
            component: institutionsPage
        },
        {
            path: '/users',
            name: 'users',
            component: usersPage
        },
        {
            path: '/profile',
            name: 'profile',
            component: userProfilePage
        },
        {
            path: '/surveys',
            name: 'surveys',
            component: surveysPage
        },
        {
            path: '/survey/:surveyID?/:institution?',
            name: 'survey-details',
            component: surveyInfoPage
        },
    ],
});

export default router;
